// @ts-nocheck
import React from "react";
import _ from "lodash";

import { reduxForm, type InjectedFormProps } from "redux-form/dist/redux-form";
import { compose } from "@reduxjs/toolkit";

import { InputField } from "kit/form";
import FormProvider from "core/FormProvider";
import { Button } from "kit/ui";
import { Validation } from "kit/helpers";

import { useModal } from "../../contexts/ModalContext";

import COUNTRY from "../../constants/COUNTRY";

import * as styles from "./UpdatePasswordModal.styles.js";


const validate = (values, props) => ({
  password2: Validation.sameAs(values.password)(values.password2)
});

const validators = {
  required: Validation.required(),
  password: Validation.pattern(COUNTRY.patterns.password, "Tu contraseña debe tener entre 4 y 20 caracteres de longitud.")
};


type ComponentPropTypes = {}
const FORM_NAME = "sharedUpdatePasswordForm";

function UpdatePasswordForm(props: InjectedFormProps & ComponentPropTypes) {

  const modal = useModal();

  const {
    handleSubmit,
    submitting,
    asyncValidating,
    fields: {
      password,
      password2
    },
    formAction
  } = props;

  const handleCloseModal = () => modal.close(UpdatePasswordForm.MODAL);

  return (
    <form
      name={FORM_NAME}
      id={FORM_NAME}
      onSubmit={handleSubmit(formAction)}
      noValidate>

      <InputField
        type="password"
        name="password"
        label="Nueva Contrase&ntilde;a"
        help="Tu contraseña debe tener entre 4 y 20 caracteres de longitud."
        required
        minLength={4}
        maxLength={20}
        validate={[
          validators.required,
          validators.password
        ]} />

      <InputField
        type="password"
        name="password2"
        label="Confirma Nueva Contrase&ntilde;a"
        required
        minLength={4}
        maxLength={20}
        validate={[
          validators.required,
          validators.password
        ]} />

      <div css={{ display: "flex" }}>
        <Button
          style={{ marginRight: 5 }}
          css={styles.btnText}
          onClick={handleCloseModal}
          outline
          size="small"
          theme="primary"
          type="button"
          disabled={submitting || asyncValidating}
          loading={submitting || asyncValidating}>
          Cancelar
        </Button>
        <Button
          id={`btn-${FORM_NAME}`}
          css={styles.btnText}
          fluid
          size="small"
          theme="orange"
          type="submit"
          disabled={submitting || asyncValidating}
          loading={submitting || asyncValidating}>
          Guardar cambios
        </Button>
      </div>

    </form>
  );
}

UpdatePasswordForm.NAME = FORM_NAME;
UpdatePasswordForm.PREFIX = "##form/SHARED/UPDATE_PASSWORD_MODAL";
UpdatePasswordForm.MODAL = "updatePasswordModal";

export default compose(
  FormProvider,
  reduxForm({
    form: FORM_NAME,
    enableReinitialize: false,
    validate,
    fields: [
      "password",
      "password2"
    ]
  })
)(UpdatePasswordForm);
